import ReactLoading from 'react-loading';

const Loading = ({ type, color }) => {
	return (
		<ReactLoading type={type} color={color} className="loading" height={'100%'} width={'100%'} z-index={999999} />
	);
};

export default Loading;
// 